import {
  Modal,
  Box,
  Typography,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
} from "@mui/material";
import { cnamActions, CnamUpdateResponse } from "../../../store/cnamSlice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

interface CnamResponseModalInterface {
  clearData: () => void;
}

export const CnamResponseModal = ({
  clearData,
}: CnamResponseModalInterface) => {
  const dispatch = useAppDispatch();
  const responseModalState = useAppSelector(
    (state) => state.cnam.cnamUpdateResponse
  );

  const onClickCloseModal = () => {
    dispatch(
      cnamActions.updateCnamResults({
        showModal: false,
        output: [],
        requestId: "",
        failedOutput: [],
      })
    );
    clearData();
  };

  return (
    <>
      <Modal open={responseModalState.showModal} onClose={onClickCloseModal}>
        <Box sx={{ alignItems: "center" }}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "clamp(400px, 40%, 800px)",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
            }}
          >
            {responseModalState.failedOutput.length > 0 ? (
              <>
                <Box sx={{ mb: 4 }}>
                  <Typography variant="h4" component="h2">
                    <span className="bold">
                      {" "}
                      The following {
                        responseModalState.failedOutput.length
                      }{" "}
                      CNAMs were NOT successfully submitted
                    </span>
                  </Typography>
                  <Paper elevation={2} sx={{ mt: 2 }}>
                    <TableContainer sx={{ maxHeight: "50vh" }}>
                      <Table stickyHeader size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>Phone Number</TableCell>
                            <TableCell>Submitted CNAM</TableCell>
                            <TableCell>Reason</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {responseModalState.failedOutput.map(
                            (output, index) => {
                              return (
                                <TableRow
                                  key={index}
                                  sx={{
                                    backgroundColor: "#ffe28b",
                                  }}
                                >
                                  <TableCell sx={{ fontFamily: "monospace" }}>
                                    {output.tn}
                                  </TableCell>
                                  <TableCell>{output.desiredCName} </TableCell>
                                  <TableCell>{output.reason} </TableCell>
                                </TableRow>
                              );
                            }
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Paper>
                </Box>
              </>
            ) : (
              <></>
            )}
            {responseModalState.output.length > 0 ? (
              <Box sx={{ mb: 4 }}>
                <Typography variant="h4" component="h2">
                  You have successfully submitted the following{" "}
                  {responseModalState.output.length} CNAMs
                </Typography>

                <Paper elevation={2} sx={{ mt: 2 }}>
                  <TableContainer sx={{ maxHeight: "50vh" }}>
                    <Table stickyHeader size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Phone Number</TableCell>
                          <TableCell>Submitted CNAM</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {responseModalState.output.map((e, index) => {
                          return (
                            <TableRow key={index}>
                              <TableCell sx={{ fontFamily: "monospace" }}>
                                {e.tn}
                              </TableCell>
                              <TableCell>{e.desiredCName}</TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
              </Box>
            ) : (
              <></>
            )}

            <Box
              sx={{
                display: "flex",
                mt: 2,
                justifyContent: "space-between",
              }}
            >
              <Typography variant="h6" sx={{ mt: 2 }}>
                Request ID:{" "}
                <span className="italic">
                  {responseModalState.requestId.length > 6
                    ? responseModalState.requestId.slice(0, 6)
                    : responseModalState.requestId}
                </span>
              </Typography>
              <Button onClick={onClickCloseModal}>Close</Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
};
